<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Company Logos</div>
            </div>
            <div class="col-md-2 offset-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="changeListOrder">Change List Order</button>
            </div>
            <div class="col-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createLogo">Add Logo</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="logos.columns" :data="logos.data">
                    <template slot="table-row" v-if="logos.data.length">
                        <tr v-for="(item, index) in logos.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.logoId}}</td>
                          <td>{{item.pageName}}</td>
                          <td>{{item.siteNameText}}</td>
                          <td  style="word-wrap: break-word">{{item.linkDestination}}</td>
                          <td  style="word-wrap: break-word">{{item.logoUrl}}</td>
                          <td><img :src="item.logoUrl" alt="expert-image" class="table-thumbnail"></td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewLogo(item)" v-tooltip.top-center="logos.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editLogo(item)" v-tooltip.top-center="logos.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const logosColumns = ['Id', 'Page', 'Site', 'Site URL', 'Logo URL', 'Image', 'Status', 'Operations'];
    export default {
        name: 'logos',
        components: {
            LTable,
        },
        data() {
        return {
              logos: {
                tooltips: {
                    view: 'View Logo',
                    edit: 'Edit Logo',
                    delete: 'Inactivate Logo',
                    activate:'Activate Logo',
                },
                columns: [...logosColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchLogos () {
            this.$store.dispatch('FETCH_LOGOS')
                    .then((res) => {
                        this.logos.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewLogo(logo){
            this.$router.push({ name: 'LogoDetail', params: { id: logo.logoId}})
        },
        editLogo(logo){
            this.$router.push({ name: 'EditLogo', params: { id: logo.logoId}})
        },
        createLogo(){
            this.$router.push({ name: 'CreateLogo'})
        },
        changeListOrder(){
          this.$router.push({ name: 'Logo Ordering'})
        }
    },
    created() {
        this.fetchLogos();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logos/Logos.vue